import 'virtual:svg-icons-register'
import.meta.glob('../img/**/*')

import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import Alpine from 'alpinejs'
import dialog from '@alpinejs/ui/src/dialog'
import popover from '@alpinejs/ui/src/popover'
import Intersect from '@alpinejs/intersect'
import focus from '@alpinejs/focus'

gsap.registerPlugin(ScrollTrigger)

import gsapMarquee from './components/gsapMarquee'
import logoFader from './components/logoFader'
import gsapSvgDraw from './components/gsapSvgDraw'
import wistiaPlayer from './components/wistiaPlayer'
import wistiaHoverVideo from './components/wistiaHoverVideo'
import workFilter from './components/workFilter'
import contentSectionFade from './contentSectionFade'

export function init() {
  const APP = window.APP || {
    CONFIG: {},
  }

  window.Alpine = Alpine

  window.APP = {
    ...APP,
    Alpine,
    components: {},
    modules: {},
  }

  Alpine.plugin(Intersect)
  Alpine.plugin(dialog)
  Alpine.plugin(popover)
  Alpine.plugin(focus)
  Alpine.data('gsapMarquee', gsapMarquee)
  Alpine.data('logoFader', logoFader)
  Alpine.data('gsapSvgDraw', gsapSvgDraw)
  Alpine.data('wistiaPlayer', wistiaPlayer)
  Alpine.data('wistiaHoverVideo', wistiaHoverVideo)
  Alpine.data('workFilter', workFilter)
  Alpine.data('siteMenu', () => ({
    menuOpen: false,

    toggle() {
      this.menuOpen = ! this.menuOpen
    },
  }))

  Alpine.start()

  contentSectionFade()

  let prev = 0
  let nav = document.querySelector('#navigation')

  window.addEventListener('scroll', function () {
    let scrollTop = window.scrollY || 0
    if (scrollTop < prev || scrollTop < 50) {
      nav.classList.remove('-translate-y-56', 'opacity-0')
    } else if (scrollTop > prev ) {
      nav.classList.add('-translate-y-56', 'opacity-0')
    }

    prev = scrollTop
  }, { passive: true })

}

window.addEventListener('DOMContentLoaded', init)


if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('HMR')
  })
}
